<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center">
        {{ year }}
        &copy; Krimans Research.
        <!-- <iconify-icon
          icon="iconamoon:heart-duotone"
          class="fs-18 align-middle text-danger"
        ></iconify-icon>
        <a href="" class="fw-bold footer-text" target="_blank">{{
          'SoftRise'
        }}</a> -->
      </div>
    </div>
  </div>
</footer>
